var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tooltip',{attrs:{"content":_vm.$t('The price depends on the settings chosen for each generation. Expand the row to see the individual charges.'),"placement":"top"}},[_c('span',{staticClass:"metered-unit-price"},[_vm._v(_vm._s(_vm.$t('varies')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }